<template>
  <div id="headerSection">
    <img alt="logo" id="logo" src="@/assets/img/logo/logo.png" />
    <div id="nav">
      <router-link
        class="navItems"
        v-bind:class="{ parentItem: navItem.subMenu }"
        :to="navItem.path"
        v-for="(navItem, index) in navItems"
        :key="index"
        exact
      >
        {{ navItem.text }}
        <ul v-if="navItem.subMenu" class="submenu">
          <li v-for="(submenu, index) in navItem.subMenu" :key="index">
            <router-link :to="submenu.path" exact>{{
              submenu.text
            }}</router-link>
          </li>
        </ul>
      </router-link>
      <img
        alt="profile"
        class="headerIcons navItems"
        id="profileIcon"
        src="@/assets/img/icon/iconsProfile.png"
      />
      <img
        alt="cart "
        class="headerIcons navItems"
        id="cartIcon"
        src="@/assets/img/icon/iconsCart.png"
      />
      <button id="downloadApp" class="navItems">Download App</button>
    </div>
    <img
      alt="menu"
      id="menuIcon"
      src="@/assets/img/icon/iconsMenu.png"
      @click.prevent="menuOpen"
    />
    <div id="menu">
      <a href id="menuClose" class="menuItems" @click.prevent="menuClose"
        ><img src="@/assets/img/icon/closeWhiteIcon.png"
      /></a>
      <div>
        <div v-for="(navItem, index) in navItems" :key="index">
          <router-link
            class="menuItems"
            :to="navItem.path"
            v-if="!navItem.subMenu"
            exact
          >
            {{ navItem.text }}
          </router-link>
          <div v-if="navItem.subMenu">
            <router-link
              v-for="(submenu, index) in navItem.subMenu"
              class="menuItems"
              :key="index"
              :to="submenu.path"
              exact
              >{{ submenu.text }}</router-link
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "headerSection",
  data: function() {
    return {
      navItems: [
        {
          path: "/",
          text: "Home"
        },
        {
          path: "#",
          text: "Our Products",
          subMenu: [
            {
              path: "/ourProducts/alphaGanith",
              text: "Alpha Ganith"
            },
            {
              path: "/ourProducts/mathematicalLaboratory",
              text: "Mathematical Laboratory"
            },
            {
              path: "/ourProducts/isrtApp",
              text: "ISRT App"
            }
          ]
        },
        {
          path: "/about",
          text: "About"
        },
        {
          path: "/contact",
          text: "Contact"
        }
      ]
    };
  },
  methods: {
    menuOpen() {
      var menu = document.getElementById("menu");
      menu.style.display = "flex";
    },
    menuClose() {
      var menu = document.getElementById("menu");
      menu.style.display = "none";
    }
  },
  watch: {
    $route() {
      document.getElementById("menu").style.display = "none";
    }
  }
};
</script>

<style lang="scss" scoped>
#headerSection {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  padding: 0 10px;
  background-color: $white;
  z-index: 5;
  display: flex;
  color: $color1;
  align-items: center;
  justify-content: space-between;
  height: $headerHeight;
}
#logo {
  height: auto;
  width: 140px;

  align-self: center;
}
.headerIcons {
  height: 25px;
}
#profileIcon {
  margin-left: 1.5rem;
  @include media-lg {
    margin-left: 3rem;
  }
}
#nav {
  display: none;
  @include media-md {
    display: flex;
    font-size: 0.9rem;
    align-items: center;
  }
}
#menuIcon {
  height: 30px;
  cursor: pointer;

  @include media-md {
    display: none;
  }
}

#menu {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  min-height: 100vh;
  background-color: $color1;
  color: $white;
  z-index: 9;
  flex-direction: column;
  margin-top: $headerHeight;
  padding-top: 30px;
  div {
    margin: 0;
    padding: 0;
  }
  .menuItems {
    margin: 10px 15px;
    display: block;
    text-align: center;
  }
  #menuClose {
    img {
      width: 30px;
      height: 30px;
    }
  }
}
#downloadApp {
  color: $white;
  background-color: $color1;
  border: none;
  border-radius: 10px;
  padding: 4px 12px;
}
.navItems,
.headerIcons,
#downloadApp,
#logo {
  margin: 0 0.5rem;
  @include media-lg {
    margin: 0 0.7rem;
  }
}
.submenu {
  display: none;
  position: relative;
  top: 5px;
  left: 0;
  background-color: transparent;
  list-style-position: outside;
  @include media-md {
    position: absolute;
    background-color: $white;
    top: 25px;
  }
  width: 250px;
  list-style: none;
  z-index: 10;
  li {
    margin: 10px 15px;
    @include media-md {
      margin: 5px 0;
    }
    display: block;
  }
}
.parentItem:hover .submenu {
  display: block;
}
</style>
